// @vendors
import { React, useContext, useEffect, useState } from "react"
import { Form, Switch } from 'antd'
import Context from '../../../context/appContext';
import { getDependencyValue } from '../../../utils/utils';

export default function SwitchField({ info, key, form, current }) {

    const { dataForm: { data, formResponses, hiddenFields, disabledFields }, setDataForm } = useContext(Context);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        getDefaultValue();
        const indexField = formResponses.findIndex(x => x.key === info.key);
        if (indexField == -1) {
            info.value = info.defaultValue;
            formResponses.push(info);
        } else {
            setChecked(formResponses[indexField].value);
        }
    }, []);

    useEffect(() => {
        disabledFields[info.key] && getDefaultValue();
    }, [disabledFields[info.key]]);

    const onChange = (event) => {
        setValue(event);
        const dependencyValue = getDependencyValue(current, info.key, event.toString(), []);
        if (dependencyValue && dependencyValue.length > 0) {
            dependencyValue.forEach(item => {
                const keyLcl = Object.keys(item)[0];
                form.setFieldsValue({ [keyLcl]: '' });
                hiddenFields[keyLcl] = item[keyLcl];
            });
            setDataForm({ data, formResponses, hiddenFields: hiddenFields, disabledFields });
        }
    }

    const setValue = (event) => {
        info.value = event;
        setChecked(event);
        const index = formResponses.findIndex(x => x.key === info.key);
        index != -1 ? formResponses[index].value = event : formResponses.push(info);
    }

    const getDefaultValue = () => {
        if (info.value && info.value !== null && info.value !== '') {
            form.setFieldsValue({ [info.key]: info.value });
            onChange(info.value);
        } else {
            const chkData = formResponses.find((item) => item.key === "datosContratanteIgualAsegurado");
            const hasCheckLoadLastStepInfo = current.newItems.find(x => x && x.key === "datosContratanteIgualAsegurado");
            if (info.customDefaultValue && (!hasCheckLoadLastStepInfo || (hasCheckLoadLastStepInfo && chkData && chkData.value))) {
                const item = formResponses.find((x) => x.key === info.customDefaultValue);
                const value = item && item.value ? item.value : '';
                form.setFieldsValue({ [info.key]: value });
                disabledFields[info.key] = true;
                onChange(value);
            }
        }
    }

    return (
        <Form.Item
            label={<td dangerouslySetInnerHTML={{ __html: info.label }} />}
            hidden={hiddenFields[info.key]}
            name={info.key}
            valuePropName='checked'
            key={key}
        >
            <Switch
                checkedChildren="SI"
                unCheckedChildren="NO"
                checked={checked}
                disabled={disabledFields[info.key]}
                onChange={onChange}
            />
        </Form.Item>
    )
}